__turbopack_context__.v({
  "current": "Spinner-module__BQAkCq__current",
  "lg": "Spinner-module__BQAkCq__lg",
  "md": "Spinner-module__BQAkCq__md",
  "primary": "Spinner-module__BQAkCq__primary",
  "sm": "Spinner-module__BQAkCq__sm",
  "spin": "Spinner-module__BQAkCq__spin",
  "spinner": "Spinner-module__BQAkCq__spinner",
  "srOnly": "Spinner-module__BQAkCq__srOnly",
  "svg": "Spinner-module__BQAkCq__svg",
  "white": "Spinner-module__BQAkCq__white",
  "xl": "Spinner-module__BQAkCq__xl",
  "xs": "Spinner-module__BQAkCq__xs",
});
